import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useContext } from 'react';
import './index.scss';
import { getVHByRem } from '@/utils/commonFunc';
import { t } from 'i18next';
import { ScreenContext } from '@/contexts/ScreenContext';
import { AudioPlayContext } from '@/contexts/AudioPlayContext';

export enum BetRecordTabPage {
    SUCCESSFUL_BETS_PAGE,
    FAILED_BETS_PAGE,
}
const StyledToggleButton = styled(ToggleButton)({
    textTransform: 'none',
    color: '#fff',
    backgroundColor: 'rgba(255, 255, 255, 0.10)',
    '&.Mui-selected': {
        backgroundColor: '#988461',
        color: '#fff',
        '& svg': {
            fill: '#404040cc',
        },
    },
    '&.Mui-selected:hover': {
        backgroundColor: '#988461',
        color: '#fff',
        '& svg': {
            fill: '#404040cc',
        },
    },
    '& svg': {
        fill: '#808080',
    },
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        color: '#fffa',
        '& svg': {
            fill: '#fffa',
        },
    },
});

export const BetRecordTabs = ({
    page,
    setPage,
}: {
    page: number;
    setPage: (page: number) => void;
}) => {
    const { isLandscape } = useContext(ScreenContext);
    const { playButtonAudio } = useContext(AudioPlayContext);

    return (
        <ToggleButtonGroup
            value={page}
            exclusive
            fullWidth
            onChange={(_, p) => {
                playButtonAudio();
                if (p !== null) setPage(p);
            }}
            sx={{
                margin: isLandscape ? getVHByRem(0.5) : '0.5rem',
                height: isLandscape
                    ? 'max(var(--vh) * 1.5 * 3, 1.5rem)'
                    : '1.84375rem',
                maxWidth: isLandscape ? '51.25%' : '100%',
            }}
        >
            <StyledToggleButton
                className="my-font-12"
                value={BetRecordTabPage.SUCCESSFUL_BETS_PAGE}
                sx={{
                    gap: isLandscape ? getVHByRem(0.3) : '0.3rem',
                }}
            >
                {t('betlog.successful')}
            </StyledToggleButton>
            <StyledToggleButton
                className="my-font-12"
                value={BetRecordTabPage.FAILED_BETS_PAGE}
            >
                {t('betlog.unsuccessful')}
            </StyledToggleButton>
        </ToggleButtonGroup>
    );
};
